export const Mensagens = {
  falhaAlteracoes: 'Falha ao cadastrar alterações! Tente novamente mais tarde.',
  falhaAlteracoesSenha: 'Não foi possível salvar a configuração. Senha incorreta.',
  configuracaoSucesso: 'Configurações salvas com sucesso!',
  validacaoConfigEmailSucesso: 'Validação das configurações de e-mail realizada com sucesso!',
  validacaoConfigEmailErro: 'Erro ao validar o configurações de e-mail. Certifique-se que todos os campos foram preenchidos corretamente e tente novamente.'
}
